import { init, NativeBridge } from "@swiggy-private/native-bridge";
import { initBridgeSdk } from "@client/includes/WebBridgeSdk";
import { safeJsonParse } from "@swiggy-private/core-ui";
import { SwgyHeadersKeys } from "@swiggy-private/checkout-core";
import { Platform } from "@client/constants/platform";

let Sdk: NativeBridge;
let platform = "";

if (typeof window !== "undefined") {
    try {
        const headers = safeJsonParse<{ [key in Partial<SwgyHeadersKeys>]: string }>(
            localStorage.getItem("auth_headers") || "{}",
        );
        platform = headers?.platform || ""; // Pass empty string as fallback
    } catch (error) {
        console.error("Error parsing auth_headers", error);
    }
}

// using webNativeBridge in case of mweb food cart migration
if (platform === Platform.MWEB) {
    Sdk = initBridgeSdk() as NativeBridge;
} else {
    Sdk = init();
}

export { Sdk };
